module.exports = __webpack_public_path__ + "static/media/instagram.662a4f14.svg";